import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    addButtonYellow: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    toUppercaseClass: {
      paddingLeft: 50,
      fontSize: 12,
      textAlign: 'center',
    },
    statusPublication: {
      paddingLeft: 100,
      fontSize: 12,
    },
    addButtonIcon: {
      fontSize: '20px !important',
      '& .MuiButton-startIcon': {
        marginRight: 2,
      },
    },
    centerLdap: {
      paddingLeft: '5px !important',
      fontSize: 12,
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    accessButtonHeader: {
      width: 40,
      fontSize: 12,
      color: palette.darkGray,
    },

    editAction: {
      display: 'flex',
      justifyContent: 'center',

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: palette.gray,
      },
    },
    textField: {
      whiteSpace: 'nowrap',
    },
    textFieldCenter: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      justifyContent: 'center',
      color: palette.darkGray,
    },
    textFieldCenterText: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      justifyContent: 'center',
      color: palette.darkGray,
      fontSize: 12,
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
    item: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: '0px 0px 0px 16px',
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'default',
      },
    },
    envRowDirect: {
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: '0px 0px 0px 16px',
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },

    indicatorRow: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      minWidth: 140,
      gap: 12,
    },
    statusLabelGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      minWidth: 0,
      marginRight: 8,
    },

    indicatorTrack: {
      position: 'relative',
      width: 70,
      height: 8,
      borderRadius: 9999,
      background: '#ECEFF3',
      overflow: 'hidden',
    },

    indicatorBar: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      borderRadius: 9999,
      transition: 'width 180ms ease',
    },
    indicatorLabel: {
      fontSize: 12,
      fontWeight: 600,
      minWidth: 32,
      marginLeft: 6,
      textAlign: 'start',
      color: palette.darkGray,
    },
    indicatorGreen: { background: palette.status.success },
    indicatorYellow: { background: palette.orange },
    indicatorRed: { background: palette.red },
    indicatorLabelRed: {
      color: palette.red,
      fontWeight: 700,
    },
    infoIcon: {
      fontSize: 14,
      cursor: 'default',
      flexShrink: 0,
    },
    eyeIcon: {
      cursor: 'pointer',
      color: palette.blue,
      fontSize: 16,
      marginLeft: 4,
    },
    clientsCell: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      justifyContent: 'center',
    },
    partnersCell: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      justifyContent: 'flex-start',
    },
    partnersCountLabel: {
      fontSize: 11,
      color: palette.darkGray,
      marginLeft: 4,
    },
    checkboxCell: {
      width: 10,
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    resetButton: {
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
    },
    tabsWrapper: {
      marginTop: 16,
      marginBottom: 8,
    },
    rootBar: {
      '& .MuiTabs-scrollable': {
        height: 35,
      },
      '& .MuiTabs-root': {
        minHeight: 35,
      },
      '& .MuiTabs-flexContainer': {
        height: 35,
      },
      '& .MuiTab-root': {
        minHeight: 35,
      },
    },
    tabsBar: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,
      '& .MuiTabs-scrollable': {
        height: 35,
      },
      '& .PrivateTabScrollButton-root': {
        height: 35,
      },
      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },
      '& .MuiTabs-root': { minHeight: 35 },
      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: palette.navCompanyContextActions,
      },
    },
    baseTabStyle: {
      transition: 'background 250ms linear',
      minHeight: 35,
      minWidth: 130,
      color: palette.deepBlack,
      fontWeight: 500,
      '&:hover': {
        textDecoration: 'none',
      },
      '&:disabled': {
        opacity: 0.7,
      },
      '& .MuiTab-wrapper': {
        fontSize: 14,
        color: palette.darkGray,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    selectedTab: {
      '&.Mui-selected': {
        backgroundColor: palette.lightNavCompanyContextActions,
      },
    },
    titleMargin: { marginTop: 16 },
    refreshButton: { padding: 0, margin: 0 },
    searchRow: {
      '& > *:first-child': { flex: 1, minWidth: 0 },
    },
    searchButton: {
      flexShrink: 0,
      marginLeft: 12,
    },
    statusLabel: { fontSize: '12px', color: palette.darkGray },
  });
